<ion-content class="theme-{{userService.theme}}">
    <ion-header><app-header></app-header></ion-header>
    <div class="white-bg" *ngIf="level === 'manager'" [@enter]>
        <div class="box content-wrap-inner" *ngIf="coachingList !== null" [@enter]>
            <div class="texts">
                <div class="text"><strong [@enter] [@leave]
                        class="primary-color">{{'__COACHING_NAME__' | translate}} </strong>
                    {{coachingList.delegate.full_name}}
                </div>
                <div class="text"><strong [@enter] [@leave]
                        class="my-color-blue">{{'__COACHING_DATE__' | translate}} </strong>
                    <div *ngIf="reportDate !==null"
                                  [@enter]="{value: '', params: {duration: 250}}">
                        {{reportDate}}</div>
                </div>
            </div>
            <div class="edit" *ngIf="this.coachingList.reports.details[slideCurrent].type === 'OTHERS'">
                <span>{{'__COACHING_EDIT__' | translate}}</span>
                <img src="assets/img/edit.svg" alt="#" class="touch-eff-radius" (click)="gotoCoachingForm()">
            </div>
        </div>
        <div class="slide-btn prev-btn" [ngClass]="{active: slideCurrent + 1 > 1}" (click)="prev()"></div>
        <div class="slide-btn next-btn" [ngClass]="{active: slideCurrent + 1 < slidesTotal}" (click)="next()"></div>
    </div>

    <ng-container *ngIf="level === 'learner'">
        <div class="white-bg" [@enter]>
            <div class="box content-wrap-inner" *ngIf="coachingList !== null" [@enter]>
                <div class="texts">
                    <div class="text">
                        <div class="coachee-name" *ngIf="reportDate !==null" [@enter]="{value: '', params: {duration: 250}}">
                            {{this.coachingList.reports.details[slideCurrent].coachee_name}}</div>
                        <div class="coachee-name" *ngIf="reportDate ===null">&nbsp;</div>
                    </div>
                    <div class="text">
                        <strong [@enter] [@leave] class="my-color-blue">{{'__COACHING_DATE__' | translate}} </strong>
                        <div *ngIf="reportDate !==null" [@enter]="{value: '', params: {duration: 250}}">
                            {{reportDate}}</div>
                    </div>
                </div>
                <div class="edit" *ngIf="this.coachingList.reports.details[slideCurrent].type === 'SELF'">
                    <span>{{'__COACHING_EDIT__' | translate}}</span>
                    <img src="assets/img/edit.svg" alt="#" class="touch-eff-radius" (click)="gotoCoachingForm()">
                </div>
            </div>
            <div class="slide-btn prev-btn" [ngClass]="{active: slideCurrent > 0}" (click)="prev()"></div>
            <div class="slide-btn next-btn" [ngClass]="{active: slideCurrent < slidesTotal - 1}" (click)="next()"></div>
        </div>
    </ng-container>

    <ion-slides [pager]="true" [options]="slideOpts" (ionSlideDidChange)="slideChanged($event)">
        <ng-container *ngIf="slideOpts !== null && coachingList !== null">
        <ion-slide *ngFor="let report of coachingList.reports.details; let i = index;">
            <app-coaching-report-single [report]="report"
                [active]="(slideCurrent === i)"></app-coaching-report-single>
        </ion-slide>
        </ng-container>
    </ion-slides>
</ion-content>
